export default "__VITE_ASSET__xO_Ot8v5__"